/* eslint-disable */
import * as BABYLON from 'babylonjs';
import Utils3D from '../utils/utils3D.js';
import { PARAM_TYPE } from './connector.js';
import { NODE_TAGS } from './graphObject.js';

export default class Utils
{
/*****************************************************************************/
static getTransformedBBoxCorners(bboxMin, bboxMax, matFinal)
{
	let vecTemp3D;
	let corners3D = [];

	// Order: left edge, top edge, right edge, (implicit) bottom edge
	// Please do not change as other code relies on this.
	vecTemp3D = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(bboxMin.x, bboxMin.y, bboxMin.z), matFinal);
	corners3D.push(vecTemp3D);

	vecTemp3D = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(bboxMin.x, bboxMin.y, bboxMax.z), matFinal);
	corners3D.push(vecTemp3D);

	vecTemp3D = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(bboxMax.x, bboxMin.y, bboxMax.z), matFinal);
	corners3D.push(vecTemp3D);

	vecTemp3D = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(bboxMax.x, bboxMin.y, bboxMin.z), matFinal);
    corners3D.push(vecTemp3D);

    vecTemp3D = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(bboxMin.x, bboxMax.y, bboxMin.z), matFinal);
    corners3D.push(vecTemp3D);

    vecTemp3D = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(bboxMin.x, bboxMax.y, bboxMax.z), matFinal);
    corners3D.push(vecTemp3D);

    vecTemp3D = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(bboxMax.x, bboxMax.y, bboxMax.z), matFinal);
    corners3D.push(vecTemp3D);

    vecTemp3D = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(bboxMax.x, bboxMax.y, bboxMin.z), matFinal);
    corners3D.push(vecTemp3D);

	return corners3D;
}
/*****************************************************************************/
static getLocalSpaceBoundingBox(pMeshList, worldMatrix)
{
	let invertedWorldMat;
	if(worldMatrix)
	{
		invertedWorldMat = new BABYLON.Matrix();
		worldMatrix.invertToRef(invertedWorldMat);
	}
	else
		invertedWorldMat = BABYLON.Matrix.Identity();
		
	let vecMin = new BABYLON.Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
	let vecMax = new BABYLON.Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);

	let currBBox;
	let currWorldMatrix;
	let totalMatrix;
	for(let pMesh of pMeshList)
	{
        if(!pMesh || !pMesh.computeWorldMatrix)
			continue;

        pMesh.computeWorldMatrix(true);
		currWorldMatrix = pMesh.getWorldMatrix();

		currBBox = pMesh.getBoundingInfo().boundingBox;
		totalMatrix = currWorldMatrix.multiply(invertedWorldMat);

		// Now, take the local bbox, compute corner point in local space, and transform it by that matrix:
		let localPoints = Utils.getTransformedBBoxCorners(currBBox.minimum, currBBox.maximum, totalMatrix);
		for(let vecPoint of localPoints)
			Utils3D.includePoint(vecPoint, vecMin, vecMax);
	}

	return { minimum: vecMin, maximum: vecMax };
}
/*****************************************************************************/
static copyCurrentParameterValues(node, copySubcomponentsValues = false)
{
	let copyDict = {'mainNode': {}, 'subcomponents': {}};

	// Save main node inputs
	addNodeInputToDict(node, copyDict['mainNode']);

	if(copySubcomponentsValues) {
		// Find subcomponents if any
		let subcomponentNodes = node.getParent().getAllNodesTagged(NODE_TAGS.SUBCOMPONENT);
		// Save their values
		for (let i = 0; i < subcomponentNodes.length; i++) {
			const subcomponent = subcomponentNodes[i];
			const assetLabel = subcomponent.getLabel();
			copyDict['subcomponents'][assetLabel] = {};
			addNodeInputToDict(subcomponent, copyDict['subcomponents'][assetLabel]);
		}
	}

	localStorage.setItem('__proc_edit_param_values__', JSON.stringify(copyDict));
}
/*****************************************************************************/
static pasteCurrentParameterValues(node, pasteSubcomponentsValues = false)
{
	let pParamsData = JSON.parse(localStorage.getItem('__proc_edit_param_values__'));
	if(!pParamsData)
		return;

	const mainNodeDict = pParamsData['mainNode'];
	setNodeInputFromDict(node, mainNodeDict);

	if(pasteSubcomponentsValues) {
		// Find subcomponents if any
		let subcomponentNodes = node.getParent().getAllNodesTagged(NODE_TAGS.SUBCOMPONENT);
		// Save their values
		for (let i = 0; i < subcomponentNodes.length; i++) {
			const subcomponent = subcomponentNodes[i];
			const assetLabel = subcomponent.getLabel();
			const subcomponentDict = pParamsData['subcomponents'][assetLabel];
			if(subcomponentDict === undefined){
				continue;
			}

			setNodeInputFromDict(subcomponent, subcomponentDict)
		}
	}


}
/*****************************************************************************/
static getObjectParameterType(pObject)
{
	if(!pObject)
		return PARAM_TYPE.ANY;

	let eResult = PARAM_TYPE.ANY;
	if(pObject.position)
		eResult = PARAM_TYPE.GEOMETRY;
	else if(pObject.getSpecificType)
		eResult = pObject.getSpecificType();
	else if(pObject.points && pObject.isClosed !== undefined)
		eResult = PARAM_TYPE.SPLINE;
	else if(pObject.maximumWorld || pObject.maximum)
		eResult = PARAM_TYPE.BBOX;

	return eResult;
}
/*****************************************************************************/
static isValidMesh(mesh)
{
	if(!mesh)
		return false;

	let positions = mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);

	// For now, we only check for NaNs, and only the first value for efficiency
	if(positions.length > 0 && isNaN(positions[0]))
		return false;

	return true;
}
/*****************************************************************************/
static getIsMeshObject(pObject)
{
	return Utils.getObjectParameterType(pObject) === PARAM_TYPE.GEOMETRY;
}
/*****************************************************************************/
static getIsSplineObject(pObject)
{
	return Utils.getObjectParameterType(pObject) === PARAM_TYPE.SPLINE;
}
/*****************************************************************************/
static haveInvalidMeshes(meshList)
{
	if(!meshList || !Array.isArray(meshList))
		return false;

	let invalidMeshNames = [];
	for(let mesh of meshList)
	{
		if(Utils.getIsMeshObject(mesh) && mesh.isDisposed())
			invalidMeshNames.push(mesh.name);
	}

	return invalidMeshNames.length === 0 ? false : invalidMeshNames;
}
/*****************************************************************************/
static getColorAsString(bjColor, fOpacity = 1.0, fValue = undefined, fSat = undefined)
{
	let finalColor = bjColor;
	if(fValue !== undefined || fSat !== undefined)
	{
		let hsv = bjColor.toHSV();
		if(fValue !== undefined)
			hsv.b = fValue;
		if(fSat !== undefined)
			hsv.s = fSat;
		finalColor = BABYLON.Color3.FromHSV(hsv.r, hsv.g, hsv.b);
	}

	return `rgba(${finalColor.r*255.0}, ${finalColor.g*255.0}, ${finalColor.b*255.0}, ${fOpacity})`;
}
/*****************************************************************************/
static isDropdownParam(parmType)
{
	return (parmType === PARAM_TYPE.DROPDOWN
					|| parmType === PARAM_TYPE.DROPDOWN_3D_MODEL
					|| parmType === PARAM_TYPE.DROPDOWN_MATERIAL
					|| parmType === PARAM_TYPE.DROPDOWN_PATH
					|| parmType === PARAM_TYPE.DROPDOWN_PROCEDURAL
					|| parmType === PARAM_TYPE.DROPDOWN_TEXTURE);
}
/*****************************************************************************/
static includeRectInBBox(rect, vecMin, vecMax)
{
	if(rect.x < vecMin.x)
		vecMin.x = rect.x;
	if(rect.y < vecMin.y)
		vecMin.y = rect.y;

	if(rect.x + rect.w > vecMax.x)
		vecMax.x = rect.x + rect.w;
	if(rect.y + rect.h > vecMax.y)
		vecMax.y = rect.y + rect.h;
}
/*****************************************************************************/
static createWorldAxes(scene, size)
{
	const ARROW_HOR_MULT = 0.025;
	const ARROW_VERT_MULT = 0.85;
	const TEXT_OFFSET = 0.05;
	const TEXT_SIZE = size*2.0;

	let funcMakeTextPlane = function (text, color, bjColor, size)
	{
		let dynamicTexture = new BABYLON.DynamicTexture("DynamicTexture", 50, scene, true);
		dynamicTexture.hasAlpha = true;
		dynamicTexture.drawText(text, 5, 40, "bold 36px Arial", color, "transparent", true);
		let plane = BABYLON.Mesh.CreatePlane("TextPlane", size, scene, true);
		plane.dontDelete = true;
		plane.material = new BABYLON.StandardMaterial("TextPlaneMaterial", scene);
		plane.material.backFaceCulling = false;
		plane.material.specularColor = new BABYLON.Color3(0, 0, 0);
		plane.material.diffuseTexture = dynamicTexture;
		plane.material.emissiveColor = bjColor.clone();
		plane.isAxis = true;
		return plane;
	};

	let axisX = BABYLON.Mesh.CreateLines("axisX", [
		BABYLON.Vector3.Zero(),
		new BABYLON.Vector3(size, 0, 0),
		new BABYLON.Vector3(size * ARROW_VERT_MULT, ARROW_HOR_MULT * size, 0),
		new BABYLON.Vector3(size, 0, 0),
		new BABYLON.Vector3(size * ARROW_VERT_MULT, -ARROW_HOR_MULT * size, 0)
	], scene);
	axisX.color = new BABYLON.Color3(1, 0, 0);
	axisX.dontDelete = true;
	axisX.isAxis = true;
	let xChar = funcMakeTextPlane("X", "red", axisX.color, TEXT_SIZE / 10);
	xChar.position = new BABYLON.Vector3(size*0.9, -TEXT_OFFSET * size, 0);

	// Prime the edge rendering engine
	axisX.enableEdgesRendering(0.88, true, { 
						epsilonVertexMerge: 1e-5, 
						removeDegeneratedTriangles: true,
						applyTessellation: true
					});
	setTimeout(() =>
	{
		axisX.disableEdgesRendering();
	}, 250);
	

	let axisY = BABYLON.Mesh.CreateLines("axisY", [
		BABYLON.Vector3.Zero(),
		new BABYLON.Vector3(0, size, 0),
		new BABYLON.Vector3(-ARROW_HOR_MULT * size, size * ARROW_VERT_MULT, 0),
		new BABYLON.Vector3(0, size, 0),
		new BABYLON.Vector3(ARROW_HOR_MULT * size, size * ARROW_VERT_MULT, 0)
	], scene);
	axisY.color = new BABYLON.Color3(0, 1, 0);
	axisY.dontDelete = true;
	axisY.isAxis = true;
	let yChar = funcMakeTextPlane("Y", "rgb(0, 255, 0)", axisY.color, TEXT_SIZE / 10);
	yChar.position = new BABYLON.Vector3(0, size*0.9, -TEXT_OFFSET * size);

	let axisZ = BABYLON.Mesh.CreateLines("axisZ", [
		BABYLON.Vector3.Zero(),
		new BABYLON.Vector3(0, 0, size),
		new BABYLON.Vector3(0, -ARROW_HOR_MULT * size, size * ARROW_VERT_MULT),
		new BABYLON.Vector3(0, 0, size),
		new BABYLON.Vector3(0, ARROW_HOR_MULT * size, size * ARROW_VERT_MULT)
	], scene);
	axisZ.color = new BABYLON.Color3(0,132/255,255/255);
	axisZ.dontDelete = true;
	axisZ.isAxis = true;
	let zChar = funcMakeTextPlane("Z", "rgb(0, 132, 255)", axisZ.color, TEXT_SIZE / 10);
	zChar.position = new BABYLON.Vector3(0, TEXT_OFFSET * size, size*0.9);
}
/*****************************************************************************/
};

function addNodeInputToDict(node, dict) {
	let pInputs = node.getInputs();
	for(let pInput of pInputs)
	{
		if(pInput.getIsInternal())
			continue;
		
		if(pInput.getConnectedNode())
			continue;

		let eType = pInput.getType();
		if(eType == PARAM_TYPE.GEOMETRY || eType == PARAM_TYPE.BBOX)
			continue;

		dict[pInput.getName()] = pInput.getLastResult();
	}
}

function setNodeInputFromDict(node, dict) {
	let pInputs = node.getInputs();
	for(let pInput of pInputs)
	{
		const strInputName = pInput.getName();
		if(dict[strInputName] === undefined)
			continue;

		node.setInputValue(strInputName, dict[strInputName]);
	}
}